/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable class-methods-use-this */

import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { GetTypeConfigurationRequest } from './types';
import { DeviceTypeConfigCapabilityResponseBody, PostConfigCapabilityResponseBody } from '../entities/config-capabilities-v1';
import { ConfigCapabilities } from '../store/admin/device-type-configuration/types';
import { axiosInstance } from "../axios-instance";

class DeviceTypeConfiguration {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  getAllConfigCapabilities(
      input: GetTypeConfigurationRequest
  ):  Promise<AxiosResponse<DeviceTypeConfigCapabilityResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<DeviceTypeConfigCapabilityResponseBody>(`${this.baseUrl}/configCapabilities`, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });
  }

  editConfigCapabilities (
    input: any,
    deviceType: string
  ): Promise<AxiosResponse<PostConfigCapabilityResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.put<PostConfigCapabilityResponseBody>(`${this.baseUrl}/configCapabilities/deviceTypes/${deviceType}`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });
  }

  createConfigCapabilities (
    input: ConfigCapabilities
  ): Promise<AxiosResponse<PostConfigCapabilityResponseBody>> {
    const payload = {
      configCapabilities: [input]
    }
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<PostConfigCapabilityResponseBody>(`${this.baseUrl}/configCapabilities`, payload, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });
  }

  /*
  getFileTypeConfigurationRecords(
    input: GetTypeConfigurationRequest,
  ): Promise<AxiosResponse<FileTypeConfigResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<FileTypeConfigResponse>(`${this.baseUrl}/configCapabilities`, {
      params: input,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  createFileTypeConfiguration(
    input: FileTypesRecord
  ): Promise<AxiosResponse<FileTypesRecord>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<FileTypesRecord>(`${this.baseUrl}/fileTypeConfigs`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
    }})
    .catch((error) => {
      throw new Error(error);
  });
  }

  editFileTypeConfiguration(
    input: FileTypesRecord
  ): Promise<AxiosResponse<FileTypesRecord>> {
    const accessToken = localStorage.getItem('accessToken');
    const {fileTypeId, ...inputWithoutFileTypeId} = input
    return axiosInstance.put<FileTypesRecord>(`${this.baseUrl}/fileTypeConfigs/${fileTypeId}`, inputWithoutFileTypeId, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
    }})
    .catch((error) => {
        throw new Error(error);
    })
  } */
}

export default DeviceTypeConfiguration;
